export const STATIC_EXTERNAL_PATH = '/external/base/img/';
export const MEDIA_VERSE_URL = 'https://apollo.olx.in';
export const fileNames = {
    APPLE_ASSET_2X: `${STATIC_EXTERNAL_PATH}/$theme$/appstore_2x.$ext$`,
    ANDROID_ASSET_2X: `${STATIC_EXTERNAL_PATH}/$theme$/playstore_2x.$ext$`,
    APPLE_ASSET_3X: `${STATIC_EXTERNAL_PATH}/$theme$/appstore_3x.$ext$`,
    ANDROID_ASSET_3X: `${STATIC_EXTERNAL_PATH}/$theme$/playstore_3x.$ext$`,
    APPLE_ASSET: `${STATIC_EXTERNAL_PATH}/$theme$/appstore.$ext$`,
    ANDROID_ASSET: `${STATIC_EXTERNAL_PATH}/$theme$/playstore.$ext$`,
    PHONE_APP_ASSET: `${STATIC_EXTERNAL_PATH}phone-app.$ext$`,
    IMG_TIPS: `${STATIC_EXTERNAL_PATH}/$theme$/chat/safety_tips.$ext$`,
    ERROR_IMG: `${STATIC_EXTERNAL_PATH}/$theme$/illustration-error.$ext$`,
    TRANSLATION_ICON: `${STATIC_EXTERNAL_PATH}translationIcon.$ext$`,
    LIMITED: `${STATIC_EXTERNAL_PATH}limited.$ext$`,
    NO_RESULTS: `${STATIC_EXTERNAL_PATH}/$theme$/noResults.$ext$`,
    LOCATION_ONBOARDING_BLOCKED_IMG: `${STATIC_EXTERNAL_PATH}/$theme$/location-onboarding/blocked/blocked-$width$.$ext$`,
    LOCATION_ONBOARDING_BLOCKED_IMG_V1: `${STATIC_EXTERNAL_PATH}/$theme$/location-onboarding/blocked/blocked-2x.webp`,
    LOCATION_ONBOARDING_GEO_IMG: `${STATIC_EXTERNAL_PATH}/$theme$/location-onboarding/geo/geo-$width$.$ext$`,
    LOCATION_ONBOARDING_GEO_IMG_V1: `${STATIC_EXTERNAL_PATH}/$theme$/location-onboarding/geo/geo-2x.webp`,
    ERROR_ALREADY_EXISTS_IMG: `${STATIC_EXTERNAL_PATH}/$theme$/errorAlreadyExists.$ext$`,

    LOGIN_ENTRY_POINT_POST: `${STATIC_EXTERNAL_PATH}/$theme$/loginEntryPointPost.$ext$`,
    LOGIN_ENTRY_POINT_CHAT: `${STATIC_EXTERNAL_PATH}/$theme$/loginEntryPointChat.$ext$`,
    LOGIN_ENTRY_POINT_FAVORITE: `${STATIC_EXTERNAL_PATH}/$theme$/loginEntryPointFavorite.$ext$`,

    MEETING_BANNER: `${STATIC_EXTERNAL_PATH}meetings/banner-2-dummy.webp`,
    MEETING_CONFIRMED: `${STATIC_EXTERNAL_PATH}meetings/meeting-confirmed.webp`,
    MEETING_CANCELLED: `${STATIC_EXTERNAL_PATH}meetings/meeting-cancelled.webp`,
    MEETING_CONFIRMED_ICON: `${STATIC_EXTERNAL_PATH}meetings/meeting-confirmed.svg`,
    MEETING_CANCELLED_ICON: `${STATIC_EXTERNAL_PATH}meetings/meeting-cancelled.svg`,
    MEETING_PENDING_ICON: `${STATIC_EXTERNAL_PATH}meetings/meeting-pending.svg`,
    MEETING_ADD_ICON: `${STATIC_EXTERNAL_PATH}meetings/add-meeting.svg`,
    MEETING_TIME_ICON: `${STATIC_EXTERNAL_PATH}meetings/meeting-time.svg`,
    STORE_TEST_DRIVE: `${STATIC_EXTERNAL_PATH}meetings/store-test-drive.webp`,
    NOTIFICATIONS: `${STATIC_EXTERNAL_PATH}/$theme$/notifications.$ext$`,
    EMPTY_CHAT: `${STATIC_EXTERNAL_PATH}/$theme$/emptyChat.$ext$`,
    NO_CHATS: `${STATIC_EXTERNAL_PATH}/$theme$/noChats.$ext$`,
    EMPTY_CHAT_TRANSACTION: `${STATIC_EXTERNAL_PATH}emptyChatTransaction.svg`,
    LOGIN_BANNER_AUTOS: `${STATIC_EXTERNAL_PATH}login-assets/olxautos/login_banner.webp`,
    LOGIN_BANNER_OTOPLUS: `${STATIC_EXTERNAL_PATH}login-assets/otoplus/login_banner.jpg`,
    NO_FILTERED_CHATS: `${STATIC_EXTERNAL_PATH}noFilteredChats.$ext$`,
    LOCATION_MODAL: `${STATIC_EXTERNAL_PATH}locationModal.$ext$`,
    CMC_LOGO: `${STATIC_EXTERNAL_PATH}cmcLogo.$ext$`,
    PAGE_404: `${STATIC_EXTERNAL_PATH}404.$ext$`,
    HANDSHAKE: `${STATIC_EXTERNAL_PATH}handshake.$ext$`,
    KEY_ICON: `${STATIC_EXTERNAL_PATH}key_icon.$ext$`,
    NOTIFY: `${STATIC_EXTERNAL_PATH}/$theme$/notify.$ext$`,
    BUSINESS_MULTI: `${STATIC_EXTERNAL_PATH}/$theme$/business_multi.$ext$`,
    BUSINESS_MULTI_TAG: `${STATIC_EXTERNAL_PATH}business_multi_tag.$ext$`,
    DISCOUNT: `${STATIC_EXTERNAL_PATH}discount.$ext$`,
    COVID_ADVISORY_IMG: `${STATIC_EXTERNAL_PATH}covid_advisory.$ext$`,
    COVID_ADVISORY_IMG_LATAM: `${STATIC_EXTERNAL_PATH}covid_advisory_latam.$ext$`,
    OLXPLEDGE: `${STATIC_EXTERNAL_PATH}olxpledge.$ext$`,
    BANNER_IMAGE: `${STATIC_EXTERNAL_PATH}bannerCMC.mobile.$ext$`,
    WARNING: `${STATIC_EXTERNAL_PATH}warning.$ext$`,
    SAFETY_TIPS_IMG: `${STATIC_EXTERNAL_PATH}olx_safety_tips.$ext$`,
    QUESTION_CLOUD_PLACEHOLDER: `${STATIC_EXTERNAL_PATH}question_cloud_placeholder`,
    FA: `${STATIC_EXTERNAL_PATH}/$theme$/fa`,
    BTT: `${STATIC_EXTERNAL_PATH}/$theme$/btt`,
    NO_PUBLICATIONS: `${STATIC_EXTERNAL_PATH}/$theme$/no-publications.$ext$`,
    EMPTY_REVIEWS: `${STATIC_EXTERNAL_PATH}empty_reviews.$ext$`,
    NO_FAVORITES: `${STATIC_EXTERNAL_PATH}/$theme$/no-favorites.$ext$`,
    EMPTY_ORDERS: `${STATIC_EXTERNAL_PATH}empty_orders.$ext$`,
    ILLUS_BILLS: `${STATIC_EXTERNAL_PATH}illus-bills.$ext$`,
    REVIEW_BAD: `${STATIC_EXTERNAL_PATH}review_bad.png`,
    REVIEW_GOOD: `${STATIC_EXTERNAL_PATH}review_good.png`,
    REVIEW_EXCELLENT: `${STATIC_EXTERNAL_PATH}review_excellent.png`,
    AVATAR_0: `${STATIC_EXTERNAL_PATH}/$theme$/chat/autos_avatar.webp`,
    AVATAR_1: `${STATIC_EXTERNAL_PATH}avatar_1.png`,
    AVATAR_2: `${STATIC_EXTERNAL_PATH}avatar_2.png`,
    AVATAR_3: `${STATIC_EXTERNAL_PATH}avatar_3.png`,
    AVATAR_4: `${STATIC_EXTERNAL_PATH}avatar_4.png`,
    AVATAR_EMPTY_STATE: `${STATIC_EXTERNAL_PATH}avatar_empty_state.png`,
    HERO_BG_UG: `${STATIC_EXTERNAL_PATH}hero-bg-ug`,
    HERO_BG_KE: `${STATIC_EXTERNAL_PATH}hero_bg_ke`,
    HERO_BG_GH: `${STATIC_EXTERNAL_PATH}hero_bg_gh`,
    HERO_BG_IN: `${STATIC_EXTERNAL_PATH}hero-bg-in.jpg`,
    HERO_BG_PK: `${STATIC_EXTERNAL_PATH}hero_bg_pk.jpg`,
    HERO_BG_ID: `${STATIC_EXTERNAL_PATH}hero_bg_id.jpg`,
    HERO_BG_AR: `${STATIC_EXTERNAL_PATH}hero-bg-ar.jpg`,
    HERO_BG_CO: `${STATIC_EXTERNAL_PATH}hero_bg_co.jpg`,
    HERO_BG_CR: `${STATIC_EXTERNAL_PATH}hero_bg_cr.jpg`,
    HERO_BG_EC: `${STATIC_EXTERNAL_PATH}hero-bg-ec.jpg`,
    HERO_BG_GT: `${STATIC_EXTERNAL_PATH}hero_bg_gt.jpg`,
    HERO_BG_PA: `${STATIC_EXTERNAL_PATH}hero_bg_pa.jpg`,
    HERO_BG_PE: `${STATIC_EXTERNAL_PATH}hero_bg_pe.jpg`,
    HERO_BG_SV: `${STATIC_EXTERNAL_PATH}hero_bg_sv.jpg`,
    HERO_BG_OLX: `${STATIC_EXTERNAL_PATH}hero_bg_olx.jpg`,
    HERO_BG_ZA: `${STATIC_EXTERNAL_PATH}hero_bg_za.jpg`,
    INSPECTED_CAR_ICN: `${STATIC_EXTERNAL_PATH}inspection-verified-icon.$ext$`,
    INSPECTED_CAR_SLIDER_ICN: `${STATIC_EXTERNAL_PATH}inspected-car-slider/verified-tag-$width$.$ext$`,
    OLX_AUTOS_CARS_SLIDER_ICN: `${STATIC_EXTERNAL_PATH}/$theme$/olx-autos-car-slider/olx-autos-icn-$width$.$ext$`,
    VERIFIED_USER: `${STATIC_EXTERNAL_PATH}verified-user-icon.$ext$`,
    INSPECTION_VERIFIED: `${STATIC_EXTERNAL_PATH}inspection-verified-icon.$ext$`,
    AUTO_ANSWER_ONBOARDING: `${STATIC_EXTERNAL_PATH}chat/auto_answer_onboarding.$ext$`,
    CROWN_ICON: `${STATIC_EXTERNAL_PATH}chat/crown.$ext$`,
    PRICING_POWERED_BY_ICON: `${STATIC_EXTERNAL_PATH}chat/powered_by.$ext$`,
    OLXAUTOS_COCO_SELLER_ICON: `${STATIC_EXTERNAL_PATH}olxLogo/olx-brand-logo_1x.$ext$`,
    OLXAUTOS_BRANDING: `${STATIC_EXTERNAL_PATH}/$theme$/chat/inbox_coco.webp`,
    THANK_YOU_TR: `${STATIC_EXTERNAL_PATH}otoplus/thankyou_2x.webp`,
    OLXAUTOS_BLUE_LOGO: `${STATIC_EXTERNAL_PATH}olxLogo/olx-brand-logo_$width$.$ext$`,
    OLXAUTOS_BLUE_SMALL_LOGO: `${STATIC_EXTERNAL_PATH}olxLogo/olx-brand-logo_$width$.$ext$`,
    OTOPLUS_SMALL_LOGO: `${STATIC_EXTERNAL_PATH}otoplus/brand_logo_small_$width$.$ext$`,
    EMPTY_STATE_INSP: `${STATIC_EXTERNAL_PATH}o2o/empty-state-home-insp.svg`,
    FEEDBACK_WARNING: `${STATIC_EXTERNAL_PATH}o2o/illustration-feedback-warning.svg`,
    OLX_AUTOS_TRANSPARENT: `${STATIC_EXTERNAL_PATH}olxAutos/olx_autos_transparent_1x.svg`,
    PICK_DATE_MOBILE: `${STATIC_EXTERNAL_PATH}meetings/PickDate-mobile.webp`,
    PICK_DATE_DESKTOP: `${STATIC_EXTERNAL_PATH}meetings/PickDate-desktop.webp`,
    ADS_ROCKET_PLACEHOLDER: `${STATIC_EXTERNAL_PATH}ads_rocket_placeholder.svg`,

    OLX_LOGO_2025: `${STATIC_EXTERNAL_PATH}olxLogo/olx_logo_2025.svg`,
    ERROR_STATE_MXCL: `${STATIC_EXTERNAL_PATH}olxAutos/404-mxcl.png`,

    MAP_ICON_PIN: `${STATIC_EXTERNAL_PATH}olxAutos/map-icon-pin.svg`,
    MAP_ICON_SELECTED_PIN: `${STATIC_EXTERNAL_PATH}olxAutos/map-icon-selected-pin.svg`,
    MAP_OTOPLUS_ICON_PIN: `${STATIC_EXTERNAL_PATH}otoplus/map-otoplus-icon-pin.svg`,
    MAP_321SPRZEDANE_ICON_PIN: `${STATIC_EXTERNAL_PATH}321sprzedane/map-321sprzedane-icon-pin.svg`,
    MAP_LOADING: `${STATIC_EXTERNAL_PATH}olxAutos/map-loading.svg`,

    FACTURA_01: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/01-Factura.jpg`,
    FACTURA_01_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/01-Factura.jpg`,
    REFACTURA_02: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/02-refactura.jpg`,
    REFACTURA_02_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/02-refactura.jpg`,
    IDENTIFICACIONOFICIAL_03: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/03-Identificacionoficial.jpg`,
    IDENTIFICACIONOFICIAL_03_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/03-Identificacionoficial.jpg`,
    IDENTIFICACIONOFICIAL_04: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/04-Identificacionoficial.jpg`,
    IDENTIFICACIONOFICIAL_04_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/04-Identificacionoficial.jpg`,
    IDENTIFICACIONOFICIAL_05: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/05-Identificacionoficial.jpg`,
    IDENTIFICACIONOFICIAL_05_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/05-Identificacionoficial.jpg`,
    TENENCIAS_06: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/06-Tenencias.jpg`,
    TENENCIAS_06_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/06-Tenencias.jpg`,
    VERIFICACION_08: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/08-Verificacion.jpg`,
    VERIFICACION_08_THUMBAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/08-Verificacion.jpg`,
    COMPROBANTEDEDOMICILIO_09: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/09-Comprobantededomicilio.jpg`,
    COMPROBANTEDEDOMICILIO_09_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/09-Comprobantededomicilio.jpg`,
    CARATULAESTADODECUENTA_12: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/12-caratulaestadodecuenta.jpg`,
    CARATULAESTADODECUENTA_12_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/12-caratulaestadodecuenta.jpg`,
    BAJADEPLACAS_16: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/16-Bajadeplacas.jpg`,
    BAJADEPLACAS_16_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/16-Bajadeplacas.jpg`,
    ENTRY_MX_20: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/20-MX-entry20.jpg`,
    ENTRY_MX_20_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/20-MX-entry20.jpg`,
    DEFAULT_MX_REQ_DOC: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/images/MX-Default.jpg`,
    DEFAULT_MX_REQ_DOC_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/mx/thumbnail-images/MX-Default.jpg`,
    CALL: `${STATIC_EXTERNAL_PATH}olxAutos/call.svg`,
    HAPPY: `${STATIC_EXTERNAL_PATH}olxAutos/happy.svg`,
    THANK_YOU: `${STATIC_EXTERNAL_PATH}olxAutos/thankyou_1x.svg`,
    THANKYOU_NOTIFY_SUCCESS: `${STATIC_EXTERNAL_PATH}olxAutos/thankyou-notify-success.svg`,
    MISSED_RESERVED: `${STATIC_EXTERNAL_PATH}olxAutos/thankyou-notify-miss.svg`,
    dowod_osobisty_zorzec_01: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/01-dowod_osobisty_zorzec.jpeg`,
    dowod_osobisty_zorzec_01_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/01-dowod_osobisty_zorzec.png`,
    dowod_rejestracyjny_wzorzec_02: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/02-dowod_rejestracyjny_wzorzec.jpeg`,
    dowod_rejestracyjny_wzorzec_02_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/02-dowod_rejestracyjny_wzorzec.png`,
    aktualna_polisa_oc_03: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/03-aktualna_polisa_oc.png`,
    aktualna_polisa_oc_03_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/03-aktualna_polisa_oc.png`,
    pelnomocnictwo_do_zawarcia_umowy_sprzedazy_samochodu_w_firmie_04: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/04-pelnomocnictwo_do_zawarcia_umowy_sprzedazy_samochodu_w_firmie_321sprzedane.png`,
    pelnomocnictwo_do_zawarcia_umowy_sprzedazy_samochodu_w_firmie_04_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/04-pelnomocnictwo_do_zawarcia_umowy_sprzedazy_samochodu_w_firmie_321sprzedane.png`,
    ksiazka_serwisowa_05: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/05-ksiazka_serwisowa.png`,
    ksiazka_serwisowa_05_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/05-ksiazka_serwisowa.png`,
    anonymyzed_swiadectwo_homologacji_sposobu_montazu_06: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/06-anonymyzed_swiadectwo_homologacji_sposobu_montazu.jpeg`,
    anonymyzed_swiadectwo_homologacji_sposobu_montazu_06_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/06-anonymyzed_swiadectwo_homologacji_sposobu_montazu.png`,
    DEFAULT_PL_REQ_DOC: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/images/brak_wzorca.png`,
    DEFAULT_PL_REQ_DOC_THUMBNAIL: `${STATIC_EXTERNAL_PATH}olxAutos/required-documents/pl/thumbnail-images/brak_wzorca.png`,

    PENDING: `${STATIC_EXTERNAL_PATH}consumer-finance/pending.svg`,
    CF_THANK_YOU: `${STATIC_EXTERNAL_PATH}consumer-finance/thank-you.svg`,
    NOTIFICATION: `${STATIC_EXTERNAL_PATH}consumer-finance/notification.svg`,
    SEARCH: `${STATIC_EXTERNAL_PATH}consumer-finance/find.svg`,
    OTOPLUS_DESKTOP_LOGO: `${STATIC_EXTERNAL_PATH}otoplus/desktop-otoplus-logo.svg`,
    OTOPLUS_MOBILE_LOGO: `${STATIC_EXTERNAL_PATH}otoplus/mobile-otoplus-logo.svg`,
    OTO_PLUS_CALL: `${STATIC_EXTERNAL_PATH}otoplus/call.svg`,
    OTO_PLUS_HAPPY: `${STATIC_EXTERNAL_PATH}otoplus/happy.svg`,
    LOGO: `${STATIC_EXTERNAL_PATH}/$theme$/logo.svg`,
    LOCK_ICON: `${STATIC_EXTERNAL_PATH}/lock.svg`,
    CONTACT_DETAILS_STORE_IMAGE: `${STATIC_EXTERNAL_PATH}olxAutos/l2q/contact_details_illustration.svg`,
    L2Q_LOADER_ANIMATION: `${STATIC_EXTERNAL_PATH}olxAutos/l2q/OLX_loader.gif`,
    NO_SLOT: `${STATIC_EXTERNAL_PATH}olxAutos/no-slots.svg`,
    BOOKING_CONFIRMATION: `${STATIC_EXTERNAL_PATH}olxAutos/booking/booking-confirmation.svg`,
    BOOKING_CANCELLED: `${STATIC_EXTERNAL_PATH}olxAutos/booking/booking-cancelled.svg`,
    CANCEL_BOOKING: `${STATIC_EXTERNAL_PATH}olxAutos/booking/cancel-booking.svg`,
    OLX_STORE: `${STATIC_EXTERNAL_PATH}olxAutos/booking/olx-store.svg`,
    BOOKING_ERROR: `${STATIC_EXTERNAL_PATH}/olxAutos/booking/error.svg`,
    OTOPLUS_STORE: `${STATIC_EXTERNAL_PATH}otoplus/booking/otoplus-store.svg`,

    CAR_INSPECTION: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/car-inspection.svg`,
    CAR_INSPECTION_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/car-inspection-tr.svg`,
    ALLOW_DEVICE_LOCATION: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/allow-device-location.svg`,
    NO_STORES_AVAILABLE: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/no-stores-available.svg`,
    CAR_INSPECTION_ENTICEMENT: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/car-inspection-enticement.svg`,
    CAR_INSPECTION_ENTICEMENT_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/car-inspection-enticement-tr.svg`,
    TAG_FREE: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/free.svg`,
    TAG_FREE_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/free-tr.svg`,
    TAG_LESS_TIME: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/less-time.svg`,
    TAG_LESS_TIME_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/less-time-tr.svg`,
    TAG_CANCEL: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/cancel.svg`,
    TAG_CANCEL_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/cancel-tr.svg`,
    BG_CIRCLE: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/circle.svg`,
    BG_CIRCLE_TR: `${STATIC_EXTERNAL_PATH}olxAutos/booking/onePage/circle-tr.svg`,

    TIP_ICON: `${STATIC_EXTERNAL_PATH}olxAutos/booking/tip.svg`,

    '321SPRZEDANE_LOGO': '/olxpl/ppc/logoWithLabel.svg',
    LOGO_321SPRZEDANE: `${STATIC_EXTERNAL_PATH}321sprzedane/logo.svg`,
    SV_CNF: '/olxcl/dealClosure/myzone/v1/light/confirmed.svg',
    SV_CNC: '/olxcl/dealClosure/myzone/v1/light/cancelled.svg',
    OLXID_LOGO: '/olxid/astra_branding/olx-indonesia-logo.svg',
    OLXID_LOGO_PNG: '/olxid/astra_branding/olx-indonesia-logo.png',

    CT_OLX_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/olx_2025.svg?v=1`,
    CT_CARWALE_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/carwale.svg?v=1`,
    CT_BIKEWALE_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/bikewale.svg?v=1`,
    CT_CARTRADE_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/cartrade.svg?v=1`,
    CT_MOBILITY_OUTLOOK_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/mobility.svg?v=1`,
    CT_CARTRADE_TECH_LOGO: `${STATIC_EXTERNAL_PATH}cartrade/logo/cartrade_tech.svg?v=1`,

    STORE_VISIT: `${STATIC_EXTERNAL_PATH}chat/store-visit.svg`,
    STORE_VISIT_MOBILE: `${STATIC_EXTERNAL_PATH}chat/store-visit-mobile.svg`,
    FIVE_STAR: `${STATIC_EXTERNAL_PATH}5star.svg`,

    DEALER_STATIC_MAP_DESKTOP: `${STATIC_EXTERNAL_PATH}dealer_static_map_desktop.svg`,
    DEALER_STATIC_MAP_MOBILE: `${STATIC_EXTERNAL_PATH}dealer_static_map_mobile.svg`,
    DEALER_VIDEO_PLAY_ICON: `${STATIC_EXTERNAL_PATH}dealer_video_play_icon.svg`,

    IMAGE_NUDGE_DESKTOP: `${STATIC_EXTERNAL_PATH}seller-img-upload-nudge.desktop.svg`,
    IMAGE_NUDGE_MOBILE: `${STATIC_EXTERNAL_PATH}seller-img-upload-nudge.mobile.svg`,

    ADPV_NUDGE: `${STATIC_EXTERNAL_PATH}seller-img-adpv-nudge.svg`,

    NUDGE_DANGER: `${STATIC_EXTERNAL_PATH}nudge-danger.svg`,
    EXPLORE_SEARCH: `${STATIC_EXTERNAL_PATH}explore-search.png`,
    PUBLISHED_DOWNLOAD_APP: `${STATIC_EXTERNAL_PATH}published_download_app.$ext$`,

    EMPTY_CART: `${STATIC_EXTERNAL_PATH}empty-cart.png`,

    COUPON_TAG: `${STATIC_EXTERNAL_PATH}coupon-tag.svg`,
    COUPON_TAG_BASE: `${STATIC_EXTERNAL_PATH}coupon-tag-white.svg`,
    CONFITTI_ANIMATION: `${STATIC_EXTERNAL_PATH}confitti-animation.json`,
    TICK_ANIMATION: `${STATIC_EXTERNAL_PATH}coupon/percentageToTickAnimation.json`
};

export const PRICE_LOADER_IMG = `${STATIC_EXTERNAL_PATH}o2o/priceLoader.svg`;

export const CAR_COMPARE_ICON = `${STATIC_EXTERNAL_PATH}olxAutos/compare/compare-icon.svg`;
export const CAR_COMPARE_ICON_FILLED = `${STATIC_EXTERNAL_PATH}olxAutos/compare/compare-icon-filled.svg`;

export const SPIN_CAR_GIF_MOBILE = '/buyers/items/v1/inspection/light/360_tag_animation_1x.gif';
export const SPIN_CAR_GIF_DESKTOP = '/buyers/items/v1/inspection/light/360_tag_animation_2x.gif';

export const LAMUDI_LOGO = '/olxid/lamudi_branding/lamudi-logo.png';
export const LAMUDI_LISTING_BANNER_DESKTOP = '/olxid/lamudi_branding/lamudi-banner.desktop.png';
export const LAMUDI_LISTING_BANNER_MOBILE = '/olxid/lamudi_branding/lamudi-banner-v1.mobile.png';
export const LAMUDI_DISMISSIBLE_BANNER_MOBILE = '/olxid/lamudi_branding/lamudi-dismissible-banner.mobile.png';
export const LAMUDI_ADPV_BANNER_DESKTOP = '/olxid/lamudi_branding/lamudi-adpv-banner.desktop.png';

export const TD_CNF = '/olxcl/dealClosure/myzone/v1/light/confirmed.svg';
export const TD_CNC = '/olxcl/dealClosure/myzone/v1/light/cancelled.svg';
export const RESERVE = '/olxcl/dealClosure/myzone/v1/light/reservationDone.svg';
export const SPIN_360_ICON = `${STATIC_EXTERNAL_PATH}olxAutos/discovery/listings/listing_360_icon.svg`;
export const RECENT_SEARCH_ICON = `${STATIC_EXTERNAL_PATH}olxAutos/discovery/listings/recent-search-icon.svg`;
export const COUNTDOWN_AD_RIGHT_ARROW = `${STATIC_EXTERNAL_PATH}countdownad/flipkart/right-white-arrow.svg`;

export const otoPlusOptionImages = {
    autosBg: '/misc/autosBannerBg.png',
    olxBg: '/misc/olxBannerBg.png'
};
export const captureIntentImages = {
    tick: `${STATIC_EXTERNAL_PATH}captureIntent/tick.png`,
    categoryImg: `${STATIC_EXTERNAL_PATH}captureIntent/`
};
export const monetRedesign = {
    Header_background: `${STATIC_EXTERNAL_PATH}redesign-monet/backgroundHeader.svg`,
    green_tick: `${STATIC_EXTERNAL_PATH}redesign-monet/tick_green.svg`,
    info_icon: `${STATIC_EXTERNAL_PATH}redesign-monet/info-icon.svg`,
    percentage: `${STATIC_EXTERNAL_PATH}redesign-monet/percentage_icon.svg`,
    trophy_cup: `${STATIC_EXTERNAL_PATH}redesign-monet/trophy.svg`,
    confirmIcon: `${STATIC_EXTERNAL_PATH}redesign-monet/confirmIcon.svg`,
    blue_tick: `${STATIC_EXTERNAL_PATH}redesign-monet/blue_tick.svg`,
    edit_icon: `${STATIC_EXTERNAL_PATH}redesign-monet/edit_icon.svg`
};
export const newMenu = {
    my_ads: `${STATIC_EXTERNAL_PATH}myAds.svg`
};

export const newSellerProfile = {
    yellow_tick: `${STATIC_EXTERNAL_PATH}new-seller-profile/yellow_tick_icon.svg`
};

export const coupon = {
    tick: `${STATIC_EXTERNAL_PATH}coupon/coupon_tick.svg`,
    percentage: `${STATIC_EXTERNAL_PATH}coupon/coupon_percentage.svg`,
    background_percentage: `${STATIC_EXTERNAL_PATH}coupon/background_icon.svg`,
    getCouponErrorIcon: `${STATIC_EXTERNAL_PATH}coupon/refetchCouponIcon.svg`
};

export const coinImg = `${MEDIA_VERSE_URL}/v1/files/ebygva1j3op5-PANAMERA/image_$width$.$ext$;original=true`;
export const verifyAccountImg = `${MEDIA_VERSE_URL}/v1/files/dm1bnvcg148j1-PANAMERA/image;original=true`;
export const gradientDiamond = `${MEDIA_VERSE_URL}/v1/files/ksg8zyj7k5hq2-PANAMERA/image;f=png;`;
export const userLookup = `${MEDIA_VERSE_URL}/v1/files/fzqz2f2hvtcl1-PANAMERA/image;f=webp;s=159x159`;
export const bannerLeftGradient = `${MEDIA_VERSE_URL}/v1/files/7qlsx97vaxqq-PANAMERA/image;s=570x324;f=webp;original=true`;
export const mobilePhonesMobileDevice = `${MEDIA_VERSE_URL}/v1/files/xddxc2rzgwn-PANAMERA/image;original=true;`;
export const mobilePhonesDesktopDevice = `${MEDIA_VERSE_URL}/v1/files/0kqa4gpvhncl2-PANAMERA/image;original=true;`;
export const carsMobileDevice = `${MEDIA_VERSE_URL}/v1/files/5sojpmq8s8qe3-PANAMERA/image;original=true;`;
export const carsDesktopDevice = `${MEDIA_VERSE_URL}/v1/files/iuot5phiezba2-PANAMERA/image;original=true;`;
